import css from "./Layout.module.css";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const location = useLocation();
  const isLogin = location.pathname === "/login";
  const isRegister = location.pathname === "/register";
  const isMain = location.pathname === "/";
  return (
    <div
      className={`${css.appContainer} ${
        isLogin || isRegister || isMain ? css.noMinWidth : ""
      }`}
    >
      {children}
      {/* SnowFlakes */}
      {/* <div className={css.snowflakeContainer}>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
        <div className={css.snowflake}>❅</div>
        <div className={css.snowflake}>❆</div>
        <div className={css.snowflake}>❄</div>
      </div> */}
    </div>
  );
}
